// @flow
import React from 'react'
import styled from 'styled-components'
import logoIcon from 'src/images/sn-logo-full.svg'
import { rhythm, scale } from 'src/typography'
import SideLinks from 'src/components/side-links'
import Logo from 'src/components/logo'
import { HeaderNavLink } from 'src/components/header'

const FooterContainer = styled.footer`
  display: flex;
  justify-content: space-between;
  height: ${rhythm(3)};
  padding: ${rhythm(0.5)};
  background: ${props => props.theme.color.primary.dark};
  .container {
    margin: 0;
    height: 100%;
  }
`

const FooterNav = styled.nav`
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0 ${rhythm(1 / 2)};
  ${scale(-1 / 4)};
  a {
    white-space: nowrap;
  }
`

const Footer = () => (
  <FooterContainer>
    <div className='container'>
      <Logo withText />
    </div>
    <FooterNav>
      <HeaderNavLink to='/privacy'>Privacy Policy</HeaderNavLink>
    </FooterNav>
    <SideLinks />
  </FooterContainer>
)

export default Footer
